<template>
  <main>
    <HeaderMarketing
      buttonTitle="Editar"
      buttonTitle2="Excluir"
      title="Marketing"
      text="Cadastre sua campanha de marketing, adicione banners e gerencie suas ações"
      :haveAction="false"
      :haveBack="false"
    />
    <!-- Modal deletar -->
    <v-dialog v-model="deleteDialog" max-width="420px">
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que remover este banner?"
        cancelBtn="Cancelar"
        okbtn="Remover"
        textObservation=""
        icone="mdi-trash-can-outline"
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="500">
      <ConfirmModal
          v-if="action"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === action).label} os usuários selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>

    <v-container style="max-width: unset" class="pa-4">
      <v-tabs
        class="pa-0 ma-0"
        background-color="#ECEEF1"
        grow
        height="35"
        hide-slider
      >
        <v-tab
          active-class="active-tab"
          class="tab"
          id="tab0"
          style="font-weight: bold !important"
          href="#mobile-tabs-5-0"
          @click="(activeTab = 0), updateTable()"
        >
          <span>Banners</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item
          :value="0"
          class="pa-0 ma-0"
          style="background-color: #eeeeee !important"
        >
          <v-card class="ma-0 pa-0">
            <!-- Cabeça -->
            <v-row class="pa-6 py-2 ma-0">
              <v-col
                class="pa-0 ma-0"
                cols="12"
                md="6"
                sm="6"
                style="justify-content: space-around; align-self: end"
              >
                <p class="texto-p">
                  Gerencie e adicione novos Banners à plataforma
                </p>
              </v-col>

              <v-col
                class="d-flex"
                style="justify-content: flex-end; align-self: center"
                cols="12"
                md="6"
                sm="6"
              >
                <v-btn
                  large
                  class="secondary-button mr-2"
                  elevation="0"
                  style="border-radius: 7.5px"
                  @click="goToRoute('/add-banner')"
                >
                  <span class="text-btn-add-banner">
                    Adicionar Novo Banner Principal</span
                  >
                </v-btn>

                <v-btn
                    large
                    class="secondary-button"
                    elevation="0"
                    style="border-radius: 7.5px"
                    @click="goToRoute('/add-banner?secondary=true')"
                >
                  <span class="text-btn-add-banner">
                    Adicionar Novo Banner secundário</span
                  >
                </v-btn>

              </v-col>
            </v-row>

            <v-card
                transition="scale-transition"
                class="d-column mt-0 mb-4 py-1"
                elevation="1"
                color="#FFFFFF"
                style="border-radius: 6px"
            >
              <v-row class="pt-3  pb-2 ma-0 justify-space-between">
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-text-field
                      v-model="filter.validate_initial"
                      outlined
                      dense
                      class="input-filter"
                      placeholder="Selecione a data de início"
                      label="Data de início"
                      hide-details="auto"
                      type="date"
                  ></v-text-field>
                </v-col>

                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-text-field
                      v-model="filter.validade_end"
                      outlined
                      dense
                      class="input-filter"
                      placeholder="Selecione a data de fim"
                      label="Data de início"
                      hide-details="auto"
                      type="date"
                  ></v-text-field>
                </v-col>

                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-autocomplete
                      v-model="filter.bannerStatus"
                      :items="statusList"
                      item-text="name"
                      color="#F5F5F5"
                      item-value="value"
                      hide-details
                      outlined
                      dense
                      class="input-filter secondary-input"
                      placeholder="Status"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-text-field
                      v-model="filter.title"
                      outlined
                      dense
                      class="input-filter"
                      placeholder="Digite o nome do banner"
                      label="Nome do banner"
                      hide-details="auto"
                      type="text"
                  ></v-text-field>
                </v-col>

                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-btn
                      outlined
                      width="100%"
                      class="quinary-button"
                      style="height: 40px!important; border-radius: 6px!important; font-size: 15px!important;"
                      large
                      @click="updateTable()"
                  >
                    Buscar
                  </v-btn>
                </v-col>

                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="4"
                    class="pa-2"
                >
                  <v-btn
                      outlined
                      width="100%"
                      style="height: 40px!important; border-radius: 6px!important; font-size: 15px!important;"
                      large
                      class="quinary-button"
                      @click="resetFilter()"
                  >
                    Limpar
                  </v-btn>
                </v-col>

              </v-row>
            </v-card>
          </v-card>

          <!-- Tabela1 -->
          <v-data-table
            ref="banner-table"
            :loading="loading"
            loading-text="Carregando..."
            no-data-text="Nenhum banner encontrado"
            :headers="headers"
            :items="banners"
            class="elevation-1 mytable mt-4 content-table"
            style="cursor: pointer"
            hide-default-footer
            :items-per-page="pageSize"
            :header-props="headerProps"
            :key="componentKey"
            v-model="selectedBanners"
            show-select
            item-key="id"
            :single-select="false"
          >
            <template v-slot:[`header.download`]="{ header }">
              <v-btn
                outlined
                tile
                icon
                v-on="header"
                class="quinary-button"
                style="border-radius: 5px"
                @click="exportExcel"
              >
                <v-icon>mdi-download-outline</v-icon>
              </v-btn>
            </template>

            <template v-slot:[`item.image`]="{ item }" style="height: 100px">
              <div style="padding: 8px 0" class="justify-center align-center">
                <v-img
                  :src="item.image"
                  :alt="item.image"
                  class="imgBanner"
                  width="144"
                  height="42"
                ></v-img>
              </div>
            </template>

            <template
              v-slot:[`item.imageMobile`]="{ item }"
              style="height: 100px"
            >
              <div style="padding: 8px 0" class="justify-center align-center">
                <v-img
                  :src="item.imageMobile"
                  :alt="item.imageMobile"
                  class="imgBanner"
                  width="144"
                  height="42"
                ></v-img>
              </div>
            </template>

            <template v-slot:[`item.validate_initial`]="{ item }">
              <div>
                {{
                  item.validate_initial != null
                    ? formatDate(item.validate_initial)
                    : item.period == 1
                    ? "Indeterminado"
                    : "Sem data determinada"
                }}
              </div>
            </template>

            <template v-slot:[`item.validate_end`]="{ item }">
              <div>
                {{
                  item.validate_end != null
                    ? formatDate(item.validate_end)
                    : item.period == 1
                    ? "Indeterminado"
                    : "Sem data determinada"
                }}
              </div>
            </template>

            <template v-slot:[`item.link`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    :href="item.link"
                    target="_blank"
                    class="ma-1 quinary-button"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-link-variant</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.link }}</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.position`]="{ item }">
              <div>
                {{ item.position == null ? "Full Banner" : item.position }}
              </div>
            </template>

            <template v-slot:[`item.bannerStatus`]="{ item }">
              <div>
                {{ item.bannerStatus == 0 ? "Inativo" : "Ativo" }}
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <section class="d-flex">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px; width: 35px; height: 35px"
                        small
                        class="quinary-button ma-1 edit-button"
                        color="quaternary"
                        @click="editBanner(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        outlined
                        fab
                        tile
                        style="border-radius: 4px; width: 35px; height: 35px"
                        small
                        class="ma-1 quinary-button"
                        color="red"
                        @click="deleteBanner(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-icon dark>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </section>
            </template>

            <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
              <v-simple-checkbox
                  :ripple="false"
                  @click="addBannerListSelectedBanners(item)"
                  :value="isSelected"
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:header.data-table-select="{ on, props}">
              <v-simple-checkbox
                  color="#bc0000"
                  v-bind="props"
                  v-on="on"
                  :ripple="false"
              >
              </v-simple-checkbox>
            </template>

            <template v-slot:footer >
              <section class="ma-0 pa-0">
                <Pagination
                    v-if="totalItems > pageSize"
                    :currentPage="currentPage"
                    :totalItems="totalItems"
                    :page="page"
                    :pageSize="pageSize"
                    :totalPages="totalPages"
                    @back-page="backPage"
                    @next-page="nextPage"
                >
                </Pagination>
              </section>

              <v-row cols="12" class="mx-5 mb-0 mt-1" v-if="selectedBanners.length > 0">
                <v-col cols="12" xs="12" sm="12" md="5" lg="4" xl="4" class="ma-0 pa-0 pa-2">
                  <label>Selecione a ação</label>
                  <v-select
                      class=""
                      dense
                      v-model="action"
                      outlined
                      style="border-radius: 3px!important"
                      :items="actions"
                      item-text="label"
                      item-value="value"
                      placeholder="Selecione a ação"
                  >
                  </v-select>

                  <section v-if="action === 4">
                    <section>
                    <label>Selecione a data de início</label>
                      <v-text-field
                          v-model="validate_initial"
                          outlined
                          dense
                          full-width
                          class="input-filter"
                          placeholder="Selecione a data de início"
                          label="Data de início"
                          hide-details="auto"
                          type="date"
                      ></v-text-field>
                    </section>

                    <section class="pt-2">
                      <label >Selecione a data de fim</label>
                      <v-text-field
                          v-model="validade_end"
                          outlined
                          dense
                          full-width
                          class="input-filter "
                          placeholder="Selecione a data de fim"
                          label="Data de início"
                          hide-details="auto"
                          type="date"
                      ></v-text-field>
                    </section>
                  </section>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-2">
                  <v-btn
                      class="secondary-button mt-5"
                      style="height: 40px!important; border-radius: 7.5px!important"
                      height="40"
                      width="100%"
                      elevation="0"
                      :disabled="!action"
                      @click="confirmActionDialog = true"
                  >
                    {{ action ? actions.find((x) => x.value === action).label : 'Selecione a ação'}}
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </main>
</template>

<style scoped>
.text-btn-add-banner {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #ffffff;
}
.imgBanner {
  background-position: center center;
  border-radius: 5px;
}
.title-g {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 40px;

  color: #000000;
}
.texto-p {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 35px;
  color: #9c9c9c;
}
.active-tab {
  background: #2d3038;
  color: #ffffff !important;
}
.input-filter{
  height: 40px!important;
  border-radius: 4px!important;
}
</style>
<script>
import HeaderMarketing from "./components/HeaderMarketing/HeaderMarketing.vue";

import DeleteModal from "../components/DeleteModal.vue";
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    HeaderMarketing,
    DeleteModal,
  },
  data: () => ({
    dialogKey: false,
    banners: [],
    selectedBanners: [],
    componentKey: false,
    deleteDialog: false,
    confirmActionDialog: false,
    activeTab: 0,
    configs: [{ label: "Criar Vitrine", value: 0 }],
    closeNoLoading: false,
    validate_initial: null,
    validade_end: null,
    env_url: "",
    apiService: new ApiService(),
    loading: false,
    page: 1,
    totalItems: 1,
    currentPage: 1,
    sizes: [15, 30, 90, 180],
    totalPages: 1,
    pageSize: 15,
    statusList: [
      { name: "Inativo", value: 0 },
      { name: "Ativo", value: 1 },
    ],
    filter: {
      title: null,
      validate_initial: null,
      validade_end: null,
      bannerStatus: null,
      page: 1,
      pageSize: 15,
    },
    headers: [
      {
        text: "Mobile",
        class: "item",
        value: "imageMobile",
        align: "center",
        sortable: false,
      },
      {
        text: "Desktop",
        class: "item",
        value: "image",
        align: "center",
        sortable: false,
      },
      {
        text: "Nome",
        class: "item",
        value: "title",
        align: "start",
        sortable: false,
      },
      {
        text: "Url",
        class: "item",
        value: "link",
        align: "start",
        sortable: false,
      },
      {
        text: "Posição",
        class: "item",
        value: "position",
        align: "start",
        sortable: false,
      },
      {
        text: "Data de início",
        class: "item",
        value: "validate_initial",
        align: "start",
        sortable: false,
      },
      {
        text: "Data de Fim",
        class: "item",
        value: "validate_end",
        align: "start",
        sortable: false,
      },

      {
        text: "Status",
        class: "item",
        value: "bannerStatus",
        align: "start",
        sortable: false,
      },

      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
    actions: [
      { label: "Inativar banner(s)", value: 1},
      { label: "Ativar banner(s)", value: 2},
      { label: "Excluir banner(s)", value: 3},
      { label: "Alterar data de início e fim do(s) banner(s)", value: 4},
    ],
    action: null,
  }),
  async created() {
    await this.updateTable();

    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.action).label) {
        case 'Inativar banner(s)':
          this.inactivateBanners()
          break
        case 'Ativar banner(s)':
          this.activateBanners()
          break
        case 'Alterar data de início e fim do(s) banner(s)':
          if (!this.validate_initial || !this.validade_end){
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "",
              message: "Status dos banners atualizados com sucesso.",
              trace: null,
            });
            return
          }
          this.changeSartEndDateBanner()
          break
        default:
          this.removeBanners()
      }
    },

    async inactivateBanners() {
      try {
        const selectedBanners = JSON.parse(JSON.stringify(this.selectedBanners))
        selectedBanners.forEach((x) => {
          x.bannerStatus = 0;
        })
        await this.apiService
            .put(`marketing/status`, selectedBanners)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos banners atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {
      }
    },

    async activateBanners() {
      try {
        const selectedBanners = JSON.parse(JSON.stringify(this.selectedBanners))
        selectedBanners.forEach((x) => {
          x.bannerStatus = 1;
        })
        await this.apiService
            .put(`marketing/status`, selectedBanners)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos banners atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {

      }
    },

    async changeSartEndDateBanner() {
      try {
        const selectedBanners = JSON.parse(JSON.stringify(this.selectedBanners))
        selectedBanners.forEach((x) => {
          x.validate_initial = this.validate_initial;
          x.validate_end = `${this.validade_end} 23:59:59`;
        })
        await this.apiService
            .put(`marketing/validateInitial-validateEnd`, selectedBanners)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Data de início e fim dos banners atualizados com sucesso.",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {

      }
    },

    async removeBanners() {
      try {
        await this.apiService
            .post(`marketing/delete-banners`, this.selectedBanners)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Banners excluídos com sucesso!",
                trace: null,
              });
              await this.updateTable()
            });

      } catch (e) {

      }
    },

    addBannerListSelectedBanners(user){
      const bannerFind = this.selectedBanners.findIndex((x) => x.id === user.id)
      if(bannerFind > -1){
        this.selectedBanners.splice(bannerFind, 1)
      } else {
        this.selectedBanners.push(user)
      }
    },

    async resetFilter(){
      this.filter = {
        title: null,
        validate_initial: null,
        validade_end: null,
        bannerStatus: null,
        page: 1,
        pageSize: 15,
      }
      this.page = 1
      await this.updateTable()
    },

    async editBanner(item) {
      this.currentBanner = item;
      const path = this.currentBanner.secondary ?
          `/add-banner?isEditing=true&id=${item.id}&secondary=true` :
          `/add-banner?isEditing=true&id=${item.id}`
      await this.$router.push({
        path,
        params: item,
      });
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`marketing/delete-banner`, this.currentBanner)
        .then((resp) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Banner removido com sucesso",
            message: "Banner removido com sucesso",
            trace: null,
          });
          this.updateTable();
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível remover o banner selecionado.",
            message: "Não foi possível remover o banner selecionado.",
            trace: null,
          });

          this.loading = false;
        });
    },

    deleteBanner(item) {
      this.currentBanner = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    formatDate(date) {
      return Utils.momentDay(date);
    },

    async updateTable() {
      // this.loading = true;
      await this.apiService
        .post(`marketing/list-banner`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.banners = response.banners;
          this.loading = false;
          this.action = null;
          this.validate_initial = null;
          this.validade_end = null;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    showSuccess(message) {
      this.$emit("show", message);
    },
  },
  watch: {
  },
};
</script>
